export * from './remaining-price';
export * from './remaining-price.props';
